import React from "react";

const Title = () => {
    return (
        <div className="list-books-title">
            <h1>MyReads</h1>
        </div>
    )
}

export default Title;